module.exports = __webpack_public_path__ + "node_modules/@taxfyle/web-commons/lib/components/AwesomeLoader/loader-512.gif";


//////////////////
// WEBPACK FOOTER
// ./~/@taxfyle/web-commons/lib/components/AwesomeLoader/loader-512.gif
// module id = 1150
// module chunks = 0